function getStringAfterFirstDot(inputString) {
  if (!inputString) return '';
  const dotIndex = inputString.indexOf('.');
  if (dotIndex !== -1) return inputString.substring(dotIndex + 1);
  return '';
}

export default getStringAfterFirstDot;
